import { render, staticRenderFns } from "./project-galleries.vue?vue&type=template&id=d9c30c6e&"
import script from "./project-galleries.vue?vue&type=script&lang=ts&"
export * from "./project-galleries.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\wamp\\www\\Pentacom\\baumit.com\\vue-project\\references\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d9c30c6e')) {
      api.createRecord('d9c30c6e', component.options)
    } else {
      api.reload('d9c30c6e', component.options)
    }
    module.hot.accept("./project-galleries.vue?vue&type=template&id=d9c30c6e&", function () {
      api.rerender('d9c30c6e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/project-galleries/project-galleries.vue"
export default component.exports